// extracted by mini-css-extract-plugin
export var aircallIframe = "_dt-3";
export var fabContainer = "_dt-5";
export var fabRinging = "_dt-6";
export var loadingOverlay = "_dt-4";
export var pulse = "_dt-7";
export var widgetContent = "_dt-2";
export var widgetPanel = "_dt-0";
export var widgetPanelExpanded = "_dt-1";